import React, { useContext, useState } from 'react';
import { flatMap } from 'lodash';

import WithdrawalService from '@app/dev/terminal/components/withdrawal/services';
import { useTranslation } from '@common/hooks/translation';
import NumericInput from '@common/components/numericInput';
import { useDataFetch } from '@common/hooks/dataFetch';
import { PopupContext } from '@app/dev/contexts/popup';
import Dropdown from '@common/components/dropdown';
import { POPUPS } from '@common/constants/popups';

import './style.scss';

const WithdrawalAmountPopup = () => {
  const t = useTranslation();
  const [{ openPopup, closePopup }] = useContext(PopupContext);
  const [betshop, setBetshop] = useState({});
  const [amount, setAmount] = useState('');
  const [error, setError] = useState('');

  const list = useDataFetch(() => WithdrawalService.getBetShopList(), []);
  const data = useDataFetch(() => WithdrawalService.getBalance(), []);

  const betshopList = list[0] || [];
  const balance = data[0]?.Limit || 0;

  const handleAmountChange = (value) => {
    const numericValue = value;
    if (numericValue > balance) {
      setAmount(numericValue);
      setError(t('Amount exceeds the available balance'));
    } else {
      setError('');
      setAmount(numericValue);
    }
  };
  const handleContinueClick = async () => {
    const result = await WithdrawalService.createCashRequest(+amount, betshop.id);
    if (result) {
      openPopup(POPUPS.WITHDRAWAL_CONFIRM_POPUP, { betshop, result });
    }
  };

  const options = flatMap(betshopList.map(({ betshops }) => betshops)).map(({ address, id }) => ({
    name: address,
    value: address,
    id,
  }));

  return (
    <div className="popup-content popup-small withdrawal-amount-popup">
      <h3 className="popup-title">{t('Withdrawal amount')}</h3>
      <div className="popup-main-content">
        <p className="text-center">{t('Please input the withdrawal amount')}</p>
        <div className="w-a-drp-title-wrp">
          <p className="w-a-drp-title">{t('Amount')}</p>
          <p className="w-a-drp-title">{`${t('available balance')}: ${balance}`}</p>
        </div>
        <div className="input-wrapper">
          <div className="input-row">
            <NumericInput
              value={amount}
              placeholder="Enter amount"
              onChange={handleAmountChange}
              className="numeric-input"
              maxDecimalCount={1}
            />
            <button
              type="button"
              disabled={!balance}
              className="w-a-balance"
              onClick={() => setAmount(balance)}
            >
              {t('Max')}
            </button>
          </div>
        </div>

        {error && <span className="w-a-error-msg">{error}</span>}
        <p className="w-a-drp-title w-a-gap">{t('Betshop')}</p>
        <Dropdown
          options={options}
          value={betshop.name}
          placeholder={t('choose betshop')}
          onChange={(value) => setBetshop(value)}
          className="w-a-dropdown"
        />
      </div>
      <div className="popup-actions">
        <button type="button" onClick={closePopup} className="popup-cancel-button">
          {t('Cancel')}
        </button>
        <button
          type="button"
          className="popup-confirm-button"
          onClick={handleContinueClick}
          disabled={!amount || !betshop.name || error}
        >
          {t('Continue')}
        </button>

      </div>
    </div>
  );
};

export default WithdrawalAmountPopup;
